import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

export const voidDocument = async (params: stdObject) => {
  const {
    setMsg2,
    docValues,
    windowValues,
    closeMsg,
    closeMsgDoc,
    setModalData2,
    logoutAction,
  } = params;
  setMsg2("loading");
  const payloadVoidDocument = {
    type: docValues.type,
    serie: docValues.serie,
    code: docValues.code,
    ...windowValues,
  };
  console.log("payloadVoidDocument", payloadVoidDocument);
  const responseVoidDocument: stdObject = await sendData({
    endPoint: "voidDocument",
    payload: payloadVoidDocument,
    logoutAction,
  });
  console.log("responseVoidDocument", responseVoidDocument);
  if (responseVoidDocument.success && responseVoidDocument.status) {
    closeMsg(2);
    setModalData2({});
    closeMsgDoc(true);
  } else {
    setMsg2("error");
    setModalData2({});
  }
};
